module.exports = __webpack_public_path__ + "img/category-casino.bf80bf83.png";